import gql from 'graphql-tag';

export const REMOVE_CONTENT_GROUP_FROM_GROUPING = gql`
  mutation removeContentGroupfromGroup($contentGroupId: Int!) {
    contentGroup {
      removeContentGroupIntoGroup(contentGroupId: $contentGroupId)
    }
  }
`;
